import { createRouteHandler } from '@mna/react'
import App from './App'
import { pageMap } from './bundles'

export default createRouteHandler({
  App,
  types: [
    { name: 'page', map: pageMap, catchAll: ['find-care-options'] },
  ],
})
